export { default } from './ModalBase';
